import { WeighingType } from '../weighing-type.enum';
export class LeaveRegistration {
    areaGateId: number;
    transportId: number;
    weighingType: WeighingType;
    weight: number;
    autoWeight: number;
    autoWeightSource: string;
    allowExitDespiteOfRuleViolation: boolean;
}
